<div class="row">
    <div class="col-md-12 border-bottom">
        <h1>Preauth Details of {{lead.lead_name}}<button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
    </div>
</div>
<div class="row mt-5"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div *ngIf="myrole=='1' || myrole=='2' || myrole=='3'">
    <div class="row mt-5" *ngIf="dataLoaded">
        <div class="col-md-8 border-right">
            <div class="row"><div class="col-md-12 text-danger border-bottom pt-2 pb-2"><i><strong class="">Note:</strong> Before upload Preauth document, please submit this form.</i></div></div>
            <br>
            <form [formGroup]="InsurancePreauthForm" (submit)="updatePreauthDetails()">
                <div class="form-group">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label">Select Hospital *</label>
                            <mat-select placeholder="Select Hospital" formControlName="preauth_hospital_id" (click)="setSearchValue('hospital')">
                                <input class="mySearchInput"
                                #hospitalSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'hospital')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="hospitalSearch">
                                <mat-option value="">Select Hospital</mat-option>
                                <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                            </mat-select>
                            <div *ngIf="preauth_submitted && f.preauth_hospital_id.errors" class="invalid-feedback">
                                <div *ngIf="f.preauth_hospital_id.errors.required">Hospital is required</div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label class="form-label">Arrival Time *</label>
                            <input type="datetime-local" formControlName="preauth_arrival_date_time" class="form-control" [min]="disableArrivalPastDate"/>
                            <div *ngIf="preauth_submitted && f.preauth_arrival_date_time.errors" class="invalid-feedback">
                                <div *ngIf="f.preauth_arrival_date_time.errors.required">Arrival Time is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="form-label" >Select Doctor *</label>
                            <mat-select placeholder="Select Doctor" [ngClass]="{'readOnly':myrole=='5'}" formControlName="preauth_doctor_id" (click)="setSearchValue('doctor')">
                                <input class="mySearchInput"
                                #doctorSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'doctor')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="doctorSearch">
                                <mat-option value="">Select Doctor</mat-option>
                                <mat-option [value]="doctor.id" *ngFor="let doctor of doctors">{{doctor.name}}</mat-option>
                            </mat-select>
                            <div *ngIf="preauth_submitted && f.preauth_doctor_id.errors" class="invalid-feedback">
                                <div *ngIf="f.preauth_doctor_id.errors.required">Doctor is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="preauth_loading" class="btn btn-primary" ><i *ngIf="preauth_loading" class="fa fa-spin fa-spinner"></i> Update</button>
                </div>
            </form>
        </div>
        <div class="col-md-4" >
            <div *ngIf="uploaddataLoaded">
                <div class="row"><div class="col-md-12 text-danger border-bottom pt-2 pb-2"><i><strong class="">Note:</strong> Aadhar,Pan and Doctor Prescription is required. If you will not upload both document, You cannot Post IPD.</i></div></div>
                <br>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Select Document Type</label>
                        <mat-select [(ngModel)]="doc_type" placeholder="Select Document Type">
                            <mat-option value="">Select Document Type</mat-option>
                            <mat-option [value]="1">Aadhar</mat-option>
                            <mat-option [value]="8">Pan</mat-option>
                            <mat-option [value]="9">Doctor Prescription</mat-option>
                            <mat-option [value]="10">Report</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Upload Documents</label>
                        <input type="file" (change)="selectFile($event)" class="form-control" />
                        <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="list-group list-group-flush list-group-hoverable">
                        <div class="list-group-item" *ngFor="let upload of allUploads">
                            <div class="row align-items-center">
                                <div class="col-md-10">
                                <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                                </div>
                                <div class="col-md-2">
                                    <a *ngIf="myrole=='1' || myrole=='2' || myrole=='3'" class="delete-file text-danger fa-pull-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                    [cancelText]="cancelText" [placement]="placement" (confirm)="removeFileInsurance(upload.id)" (cancel)="cancelClicked = true"
                                    confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                    [appendToBody]="true"><i class="fa fa-trash"></i></a>
                                </div>
                                <div class="col text-truncate">
                                    <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Aadhar/ Other Docs</span>
                                    <span class="badge badge-info" *ngIf='upload.upload_type==8'>Pan</span>
                                    <span class="badge badge-secondary" *ngIf='upload.upload_type==9'>Doctor Prescription</span>
                                    <span class="badge badge-primary" *ngIf='upload.upload_type==10'>Report</span>
                                    <span class="float-right badge badge-default">{{upload.created_at*1000|date:'dd MMM, yyyy hh:mm aa'}}</span>
                                    <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
            